var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTag = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.021 41.021",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "3px",
  d: "M0,0H17.509l5.836,5.836-6.253,5.836H0Z",
  transform: "translate(11.673 23.869) rotate(-45)"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 1.668,
  cy: 1.668,
  r: 1.668,
  transform: "translate(25.013 15.008)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.172 9.172)"
}, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "3px",
  y1: 6.67,
  transform: "translate(3.335)"
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "3px",
  x2: 6.67,
  transform: "translate(0 3.335)"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.2c39ab8f.svg";
export { ForwardRef as ReactComponent };